import { useThemeContext } from '@huggg/react-components';
import errorImage from 'assets/img/nohugggs.png';
import classnames from 'classnames';
import dictionary from 'config/dictionary.json';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './error.module.scss';

const BaseError = (props) => {
  const { operator } = useThemeContext();
  const { className, errorMessage, render } = props;

  return (
    <div className={classnames('container', styles.container, className)}>
      {render && render.constructor === Function ? (
        render()
      ) : (
        <>
          {operator.showHugggPromotions && (
            <img
              src={errorImage}
              alt="icon denoting no items found"
              className={styles.image}
            />
          )}

          <p className={styles.summary} data-test-id="error-message-default">
            {!operator.exposeApiErrorMessages &&
            typeof errorMessage === 'string' &&
            /huggg|intercom|mailto:/i.test(errorMessage)
              ? `${dictionary.error.default} ${operator.support}`
              : errorMessage || dictionary.error.default}
          </p>
        </>
      )}
    </div>
  );
};

BaseError.propTypes = {
  className: PropTypes.string,
  errorDetails: PropTypes.object,
  errorMessage: PropTypes.string,
  render: PropTypes.func,
};

export default BaseError;
